import React, { useEffect, useState } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { StyledPageTitle } from 'theme/styles';
import { TabMenu } from 'components/molecules/TabMenu';
import { useQuery } from 'hooks/useQuery';
import LicencesPage from './licences';
import PrintoutsPage from './printouts';
import { useLocation } from 'react-router-dom';
import { replaceUrlIfOnPage } from 'utils/history';
import BatchesPage from './Batches/BatchesPage';
import { usePermission } from 'hooks/usePermission';
import { EPermission } from 'models/permissions';

export enum ETabId {
  licences = 'licences',
  printouts = 'printouts',
  batches = 'batches',
}

const LicencesTabsPage = () => {
  const { t } = useTranslations();
  const { pathname }: any = useLocation();
  const query = useQuery();
  const expand: string | null = query.get('expand');
  const { hasPermissions } = usePermission();
  const hasPrintPermission = !!hasPermissions(EPermission.PRINT_LICENCE);

  const [defaultTab, setDefaultTab] = useState(0);

  const getNewQueryPath = (tabName: ETabId) => {
    const newPathname = `${pathname}?expand=${tabName}`;
    replaceUrlIfOnPage(newPathname);
  };

  const tabs = [
    {
      name: 'licences',
      title: t('module.licences.name'),
      content: <LicencesPage />,
    },
    ...(hasPrintPermission
      ? [
          { name: 'printouts', title: t('module.printouts.name'), content: <PrintoutsPage /> },
          {
            name: 'batches',
            title: t('module.batches.name'),
            content: <BatchesPage />,
          },
        ]
      : []),
  ];

  useEffect(() => {
    if (expand) {
      switch (expand) {
        case ETabId.licences:
          setDefaultTab(0);
          break;
        case ETabId.printouts:
          setDefaultTab(1);
          break;
        case ETabId.batches:
          setDefaultTab(2);
          break;
        default:
          setDefaultTab(0);
          break;
      }
    }
  }, [expand]);

  return (
    <>
      <Breadcrumbs items={[t('module.licences.name')]} />
      <StyledPageTitle variant="h4" style={{ marginBottom: '16px' }}>
        {t('module.licences.name')}
      </StyledPageTitle>
      <TabMenu
        tabs={tabs}
        defaultTab={defaultTab}
        onChangeTab={getNewQueryPath}
        hideIfOneTab
      />
    </>
  );
};

export default LicencesTabsPage;
